import { render, staticRenderFns } from "./DogRegistrationIndividualKennelNameUsageSignatures.vue?vue&type=template&id=1894fa18"
import script from "./DogRegistrationIndividualKennelNameUsageSignatures.vue?vue&type=script&lang=ts"
export * from "./DogRegistrationIndividualKennelNameUsageSignatures.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports